module.exports = __webpack_public_path__ + "img/iam-logo.13281779.jpg";